import type { PracticeDepthMap } from "./depth-types";

/** Depth content: labour, tax, ip, notary-international, pdpa. */
export const PRACTICE_DEPTH_B: PracticeDepthMap = {
  labour: {
    answer:
      "งานแรงงานและคนต่างชาติของสำนักงานครอบคลุมการร่างและตรวจสัญญาจ้าง ระเบียบข้อบังคับการทำงาน การเลิกจ้างให้เป็นไปตามขั้นตอน ข้อพิพาทค่าชดเชยและค่าจ้าง ตลอดจนใบอนุญาตทำงานและวีซ่าของพนักงานต่างชาติ ทีมงานดูทั้งเอกสารฝ่ายบุคคลและความเสี่ยงทางคดีไปพร้อมกัน",
    seoTitle: "กฎหมายแรงงานและคนต่างชาติ — สัญญาจ้าง เลิกจ้าง ใบอนุญาต",
    seoDesc:
      "สัญญาจ้าง ระเบียบข้อบังคับ การเลิกจ้าง ค่าชดเชย ข้อพิพาทศาลแรงงาน ใบอนุญาตทำงานและวีซ่าพนักงานต่างชาติ พร้อมเอกสาร ขั้นตอน และข้อควรระวัง",
    audience: [
      "ฝ่ายบุคคลที่ต้องจัดทำสัญญาจ้างและระเบียบข้อบังคับให้ถูกต้อง",
      "นายจ้างที่ต้องเลิกจ้างและต้องการทำตามขั้นตอนเพื่อลดความเสี่ยงคดี",
      "ลูกจ้างที่ถูกเลิกจ้างและไม่ทราบสิทธิเรื่องค่าชดเชย",
      "บริษัทที่จ้างพนักงานต่างชาติและต้องดูวีซ่ากับใบอนุญาตทำงาน",
      "ธุรกิจที่ใช้ผู้รับจ้างอิสระและต้องตรวจว่าจัดประเภทถูกต้องหรือไม่",
    ],
    compare: {
      heading: "ลูกจ้างประจำ สัญญาจ้างมีกำหนด และผู้รับจ้างอิสระ",
      intro:
        "ชื่อที่เขียนในสัญญาไม่ได้ตัดสินสถานะเสมอไป สิ่งที่ดูคือลักษณะการทำงานจริง ตารางนี้ช่วยให้เห็นภาระของแต่ละรูปแบบ",
      columns: ["ลูกจ้างประจำ", "สัญญาจ้างมีกำหนดเวลา", "ผู้รับจ้างอิสระ"],
      rows: [
        {
          label: "ลักษณะงานจริง",
          cells: ["อยู่ใต้บังคับบัญชา มีเวลาทำงานและวินัยองค์กร", "ทำงานเฉพาะช่วง โดยงานมีลักษณะไม่ต่อเนื่อง", "ทำงานตามผลลัพธ์ กำหนดวิธีทำงานเอง"],
        },
        {
          label: "สิทธิตามกฎหมายแรงงาน",
          cells: ["ได้รับความคุ้มครองเต็มรูปแบบ", "ได้รับความคุ้มครอง โดยเงื่อนไขสิ้นสุดขึ้นกับลักษณะงาน", "ไม่ใช่ลูกจ้าง หากลักษณะงานเป็นเช่นนั้นจริง"],
        },
        {
          label: "เอกสารที่ควรมี",
          cells: ["สัญญาจ้าง ระเบียบข้อบังคับ หนังสือรับทราบวินัย", "สัญญาที่ระบุงานและช่วงเวลาให้ชัด", "สัญญาจ้างทำของหรือสัญญาบริการ พร้อมหลักฐานการส่งมอบงาน"],
        },
        {
          label: "จุดเสี่ยงที่พบบ่อย",
          cells: [
            "ไม่มีเอกสารตักเตือนก่อนเลิกจ้าง",
            "ต่อสัญญาซ้ำ ๆ ทั้งที่งานมีลักษณะต่อเนื่อง",
            "เรียกว่าผู้รับจ้างแต่ควบคุมเวลาและวิธีทำงานเหมือนลูกจ้าง",
          ],
        },
      ],
      note: "หากลักษณะการทำงานจริงเป็นลูกจ้าง ศาลพิจารณาตามข้อเท็จจริง ไม่ได้ดูเพียงชื่อสัญญา",
    },
    faqs: [
      {
        question: "เลิกจ้างต้องบอกกล่าวล่วงหน้าหรือไม่",
        answer:
          "โดยหลักต้องบอกกล่าวล่วงหน้าตามรอบการจ่ายค่าจ้าง หรือจ่ายค่าจ้างแทนการบอกกล่าว เว้นแต่มีเหตุตามกฎหมายที่ยกเว้นได้ ควรทำเป็นหนังสือและเก็บหลักฐานการรับทราบไว้",
      },
      {
        question: "ค่าชดเชยคำนวณจากอะไร",
        answer:
          "คำนวณจากอัตราค่าจ้างสุดท้ายและระยะเวลาทำงานตามอัตราขั้นที่กฎหมายกำหนด กรณีที่มีการยกเว้นไม่ต้องจ่ายมีขอบเขตจำกัดและต้องมีพยานหลักฐานสนับสนุนชัดเจน",
      },
      {
        question: "ลูกจ้างทำผิดวินัยเลิกจ้างได้ทันทีไหม",
        answer:
          "ขึ้นกับความร้ายแรงของการกระทำและเอกสารที่มี กรณีความผิดไม่ร้ายแรงมักต้องมีหนังสือตักเตือนก่อน การเลิกจ้างโดยไม่มีเอกสารรองรับมักเป็นเหตุให้ถูกฟ้องเรียกค่าชดเชย",
      },
      {
        question: "ระเบียบข้อบังคับการทำงานจำเป็นแค่ไหน",
        answer:
          "เมื่อมีลูกจ้างถึงจำนวนที่กฎหมายกำหนดต้องจัดทำและประกาศให้ลูกจ้างทราบ ระเบียบที่เขียนไว้ชัดช่วยให้การลงโทษทางวินัยและการเลิกจ้างมีฐานอ้างอิงที่ตรวจสอบได้",
      },
      {
        question: "ลูกจ้างลาออกเองได้ค่าชดเชยไหม",
        answer:
          "การลาออกโดยสมัครใจโดยหลักไม่มีสิทธิได้ค่าชดเชย แต่หากข้อเท็จจริงแสดงว่าถูกกดดันให้ลาออกหรือเป็นการเลิกจ้างโดยปริยาย ประเด็นนี้อาจถูกโต้แย้งได้ในศาลแรงงาน",
      },
      {
        question: "ฟ้องศาลแรงงานต้องเสียค่าธรรมเนียมไหม",
        answer:
          "คดีแรงงานมีลักษณะที่ออกแบบให้ลูกจ้างเข้าถึงได้ง่ายกว่าคดีแพ่งทั่วไป และศาลมักไกล่เกลี่ยก่อนสืบพยาน ควรเตรียมสลิปเงินเดือน สัญญาจ้าง และหนังสือเลิกจ้างให้ครบก่อนยื่น",
      },
      {
        question: "จ้างพนักงานต่างชาติต้องมีอะไรก่อนเริ่มงาน",
        answer:
          "ต้องมีวีซ่าประเภทที่ถูกต้องและใบอนุญาตทำงานที่ระบุนายจ้างกับลักษณะงานให้ตรงกับงานจริง การเริ่มทำงานก่อนได้รับอนุญาตมีความเสี่ยงทั้งต่อนายจ้างและตัวพนักงาน",
      },
      {
        question: "เปลี่ยนตำแหน่งพนักงานต่างชาติต้องแจ้งไหม",
        answer:
          "หากลักษณะงานหรือสถานที่ทำงานเปลี่ยนไปจากที่ระบุไว้ ต้องดำเนินการแก้ไขรายการในใบอนุญาตให้สอดคล้อง การปล่อยให้ข้อมูลไม่ตรงเป็นประเด็นที่ถูกตรวจสอบได้ในภายหลัง",
      },
      {
        question: "บริษัทต้องมีสัดส่วนลูกจ้างไทยต่อชาวต่างชาติหรือไม่",
        answer:
          "มีหลักเกณฑ์เกี่ยวกับอัตราส่วนและทุนจดทะเบียนที่ใช้พิจารณาการอนุญาตทำงาน รายละเอียดต่างกันตามช่องทางที่ใช้ยื่น ควรตรวจก่อนรับพนักงานเข้าทำงานเพื่อไม่ให้ติดปัญหาระหว่างทาง",
      },
      {
        question: "ลูกจ้างประสบอุบัติเหตุจากการทำงานต้องทำอย่างไร",
        answer:
          "ต้องดำเนินการตามระบบเงินทดแทนและเก็บเอกสารการรักษาให้ครบ นายจ้างควรบันทึกเหตุการณ์และแจ้งตามกำหนดเวลา การละเลยขั้นตอนนี้อาจทำให้เกิดข้อพิพาทเรื่องความรับผิดในภายหลัง",
      },
      {
        question: "ข้อสัญญาห้ามไปทำงานกับคู่แข่งบังคับได้ไหม",
        answer:
          "บังคับได้เท่าที่มีขอบเขตพอสมควรทั้งเรื่องระยะเวลา พื้นที่ และประเภทงาน ข้อสัญญาที่กว้างเกินไปมีความเสี่ยงถูกปรับลดหรือไม่ได้รับการบังคับตามที่เขียนไว้",
      },
      {
        question: "ให้สำนักงานตรวจเอกสารฝ่ายบุคคลทั้งชุดได้ไหม",
        answer:
          "ได้ ทีมงานรับตรวจสัญญาจ้าง ระเบียบข้อบังคับ แบบฟอร์มตักเตือน หนังสือเลิกจ้าง และเอกสารพนักงานต่างชาติทั้งชุด แล้วสรุปจุดที่ควรแก้ก่อนเกิดข้อพิพาท",
      },
    ],
    related: ["corporate", "litigation", "tax"],
    imageAlt: "ฝ่ายบุคคลและทนายความตรวจสัญญาจ้างงานร่วมกันในห้องประชุมสำนักงานที่กรุงเทพ",
  },

  tax: {
    answer:
      "งานภาษีและบัญชีของสำนักงานครอบคลุมการวางระบบเอกสารให้สอดคล้องกับธุรกรรมจริง ยื่นแบบตามรอบ ปิดงบการเงิน ตรวจภาระภาษีของธุรกรรมสำคัญ เช่น การโอนอสังหาริมทรัพย์และการจ่ายเงินไปต่างประเทศ รวมถึงการชี้แจงและอุทธรณ์เมื่อถูกประเมิน โดยทำงานร่วมกับทีมกฎหมายในเรื่องเดียวกัน",
    seoTitle: "ภาษีและบัญชีธุรกิจ — ยื่นแบบ ปิดงบ และชี้แจงการประเมิน",
    seoDesc:
      "วางระบบเอกสารทางภาษี ยื่นแบบตามรอบ ปิดงบการเงิน ตรวจภาระภาษีธุรกรรมสำคัญ และชี้แจงหรืออุทธรณ์เมื่อถูกประเมิน พร้อมขั้นตอนและข้อควรระวัง",
    audience: [
      "บริษัทที่ต้องการให้ระบบเอกสารและงบการเงินตรงกับธุรกรรมจริง",
      "ธุรกิจที่ได้รับหนังสือเชิญพบหรือหนังสือแจ้งประเมิน",
      "ผู้ที่จะโอนอสังหาริมทรัพย์และต้องทราบภาระภาษีก่อนทำสัญญา",
      "บริษัทที่จ่ายค่าบริการหรือค่าสิทธิไปต่างประเทศ",
      "ผู้ประกอบการที่ต้องพิจารณาการจดทะเบียนภาษีมูลค่าเพิ่ม",
    ],
    compare: {
      heading: "เอกสารครบ กับ เอกสารไม่ครบ — ผลต่างเวลาถูกตรวจ",
      intro:
        "ประเด็นภาษีส่วนใหญ่ที่ลุกลามเป็นข้อพิพาทมาจากเอกสารประกอบรายการไม่ครบ ไม่ใช่จากการตีความกฎหมายที่ซับซ้อน",
      columns: ["ระบบเอกสารครบและสอดคล้อง", "เอกสารไม่ครบหรือไม่สอดคล้อง"],
      rows: [
        {
          label: "การชี้แจงเมื่อถูกตรวจ",
          cells: ["อ้างอิงเอกสารต่อรายการได้ทันที", "ต้องย้อนหาเอกสารและอธิบายด้วยคำบอกเล่า"],
        },
        {
          label: "ความเสี่ยงถูกประเมินเพิ่ม",
          cells: ["ต่ำกว่า เพราะรายการมีหลักฐานรองรับ", "สูงกว่า และอาจมีเบี้ยปรับเงินเพิ่ม"],
        },
        {
          label: "รายการที่มักเป็นปัญหา",
          cells: ["ตรวจพบและแก้ไขได้ในรอบบัญชี", "ค่าใช้จ่ายไม่มีใบกำกับ รายการกับกรรมการ เงินสดรับจ่ายที่ไม่มีร่องรอย"],
        },
        {
          label: "ผลต่อธุรกรรมในอนาคต",
          cells: ["ขอสินเชื่อหรือขายกิจการง่ายกว่า", "ถูกขอเอกสารเพิ่มและมักกระทบมูลค่าในการเจรจา"],
        },
      ],
      note: "การจัดเอกสารย้อนหลังทำได้จำกัด การวางระบบตั้งแต่ต้นรอบจึงคุ้มกว่าเสมอ",
    },
    faqs: [
      {
        question: "บริษัทต้องยื่นแบบอะไรเป็นประจำ",
        answer:
          "โดยทั่วไปมีการยื่นแบบภาษีเงินได้นิติบุคคลตามรอบบัญชีทั้งครึ่งปีและสิ้นปี ภาษีหัก ณ ที่จ่ายเป็นรายเดือน และภาษีมูลค่าเพิ่มรายเดือนหากจดทะเบียนไว้ พร้อมนำส่งงบการเงินตามกำหนด",
      },
      {
        question: "ต้องจดทะเบียนภาษีมูลค่าเพิ่มเมื่อไร",
        answer:
          "เมื่อรายได้ถึงเกณฑ์ที่กฎหมายกำหนด หรือเมื่อประกอบกิจการที่ต้องจดทะเบียน บางธุรกิจเลือกจดก่อนถึงเกณฑ์เพื่อใช้ภาษีซื้อ ควรประเมินโครงสร้างลูกค้าและต้นทุนก่อนตัดสินใจ",
      },
      {
        question: "ค่าใช้จ่ายแบบไหนที่มักถูกตัดออก",
        answer:
          "รายการที่ไม่มีเอกสารรองรับ ไม่เกี่ยวกับกิจการโดยตรง หรือเป็นรายจ่ายส่วนตัวของกรรมการที่ผ่านบัญชีบริษัท รวมถึงรายการที่ไม่มีหลักฐานการชำระที่ตรวจสอบได้",
      },
      {
        question: "ได้รับหนังสือเชิญพบเจ้าพนักงานควรทำอย่างไร",
        answer:
          "อย่าเพิกเฉยและอย่าให้ถ้อยคำก่อนตรวจเอกสารของตนเอง ควรรวบรวมเอกสารที่เกี่ยวกับประเด็นที่ถูกถาม แล้วให้ที่ปรึกษาตรวจร่วมก่อนเข้าชี้แจง เพื่อให้คำชี้แจงตรงกับเอกสาร",
      },
      {
        question: "ถูกประเมินภาษีแล้วโต้แย้งได้ไหม",
        answer:
          "โต้แย้งได้ตามช่องทางอุทธรณ์ที่กฎหมายกำหนด และมีกำหนดเวลาที่ต้องระวัง การปล่อยให้เลยกำหนดทำให้เสียสิทธิ จึงควรตรวจวันที่ในหนังสือแจ้งเป็นเรื่องแรก",
      },
      {
        question: "ขายที่ดินหรือบ้านต้องเสียภาษีอะไร",
        answer:
          "มีค่าธรรมเนียมและภาษีหลายรายการที่คำนวณจากราคาประเมินหรือราคาขาย ระยะเวลาถือครอง และสถานะผู้ขายว่าเป็นบุคคลธรรมดาหรือนิติบุคคล ควรคำนวณก่อนตกลงราคาในสัญญา",
      },
      {
        question: "จ่ายเงินไปต่างประเทศต้องหักภาษีไหม",
        answer:
          "ขึ้นกับประเภทเงินที่จ่าย เช่น ค่าบริการ ค่าสิทธิ หรือดอกเบี้ย และขึ้นกับว่ามีอนุสัญญาภาษีซ้อนกับประเทศผู้รับหรือไม่ ควรตรวจก่อนโอนเงิน เพราะแก้ย้อนหลังยาก",
      },
      {
        question: "บริษัทขาดทุนต้องยื่นแบบไหม",
        answer:
          "ต้องยื่นตามกำหนดแม้ผลประกอบการขาดทุน และการยื่นให้ครบถ้วนยังเป็นเงื่อนไขสำคัญต่อการใช้ผลขาดทุนสะสมในปีต่อไปตามหลักเกณฑ์ที่กำหนด",
      },
      {
        question: "กรรมการยืมเงินบริษัทได้ไหม",
        answer:
          "ทำได้แต่ต้องมีเอกสารสัญญาและเงื่อนไขที่สมเหตุสมผล รวมถึงบันทึกทางบัญชีที่ชัดเจน รายการเงินให้กู้แก่กรรมการที่ไม่มีเอกสารเป็นประเด็นที่ถูกตรวจสอบบ่อย",
      },
      {
        question: "เอกสารทางบัญชีต้องเก็บกี่ปี",
        answer:
          "ต้องเก็บตามระยะเวลาที่กฎหมายบัญชีและกฎหมายภาษีกำหนด และควรเก็บให้ค้นได้เป็นระบบทั้งฉบับกระดาษและไฟล์ เพราะการตรวจสอบมักย้อนหลังหลายรอบบัญชี",
      },
      {
        question: "จะให้ทีมกฎหมายกับทีมบัญชีทำงานร่วมกันได้ไหม",
        answer:
          "ได้ และเป็นข้อดีของการใช้สำนักงานที่ดูแลทั้งสองด้าน เพราะเอกสารสัญญากับการบันทึกบัญชีต้องสอดคล้องกัน หากแยกกันทำมักเกิดช่องว่างที่กลายเป็นประเด็นตอนถูกตรวจ",
      },
      {
        question: "เริ่มต้นตรวจสุขภาพภาษีของบริษัทอย่างไร",
        answer:
          "นำงบการเงินปีล่าสุด แบบที่ยื่นไว้ และตัวอย่างเอกสารรายการหลักเข้ามาให้ทีมงานตรวจ จะเห็นได้ว่ารายการใดขาดเอกสารและควรแก้ระบบส่วนไหนก่อน ค่าบริการประเมินเป็นรายเรื่อง",
      },
    ],
    related: ["corporate", "property", "labour"],
    imageAlt: "นักบัญชีและทนายความตรวจเอกสารบัญชีและใบกำกับภาษีร่วมกันบนโต๊ะทำงาน",
  },

  ip: {
    answer:
      "งานทรัพย์สินทางปัญญาของสำนักงานครอบคลุมการตรวจและยื่นจดทะเบียนเครื่องหมายการค้า การดูแลลิขสิทธิ์และสิทธิบัตร การร่างสัญญาอนุญาตให้ใช้สิทธิและสัญญาโอนสิทธิ ไปจนถึงการดำเนินการเมื่อมีการละเมิด ทั้งการมีหนังสือแจ้งเตือน การแจ้งลบเนื้อหา และการดำเนินคดี",
    seoTitle: "ทรัพย์สินทางปัญญา — เครื่องหมายการค้า ลิขสิทธิ์ สิทธิบัตร",
    seoDesc:
      "ตรวจและยื่นจดเครื่องหมายการค้า ดูแลลิขสิทธิ์และสิทธิบัตร ร่างสัญญาอนุญาตให้ใช้สิทธิ และดำเนินการเมื่อถูกละเมิด พร้อมขั้นตอนและข้อควรระวัง",
    audience: [
      "เจ้าของแบรนด์ที่ต้องการจดเครื่องหมายการค้าให้ครอบคลุมสินค้าที่ขายจริง",
      "ผู้สร้างเนื้อหาที่พบว่างานของตนถูกนำไปใช้โดยไม่อนุญาต",
      "ธุรกิจที่ต้องร่างสัญญาอนุญาตให้ใช้สิทธิหรือสัญญาจ้างผลิตงาน",
      "ผู้ประกอบการที่ได้รับหนังสือกล่าวหาว่าละเมิดสิทธิของผู้อื่น",
      "ผู้ขายออนไลน์ที่ต้องจัดการสินค้าลอกเลียนบนแพลตฟอร์ม",
    ],
    compare: {
      heading: "เครื่องหมายการค้า ลิขสิทธิ์ และสิทธิบัตร คุ้มครองต่างกัน",
      intro:
        "หลายธุรกิจเข้าใจว่าจดอย่างหนึ่งแล้วคุ้มครองทุกอย่าง ความจริงคือแต่ละสิทธิคุ้มครองสิ่งที่ต่างกันและมีขั้นตอนต่างกัน",
      columns: ["เครื่องหมายการค้า", "ลิขสิทธิ์", "สิทธิบัตร / อนุสิทธิบัตร"],
      rows: [
        {
          label: "คุ้มครองอะไร",
          cells: ["ชื่อ โลโก้ หรือเครื่องหมายที่ใช้กับสินค้าและบริการ", "งานสร้างสรรค์ เช่น งานเขียน ภาพ เสียง ซอฟต์แวร์", "การประดิษฐ์หรือการออกแบบที่มีเงื่อนไขตามกฎหมาย"],
        },
        {
          label: "เกิดสิทธิเมื่อใด",
          cells: ["เมื่อจดทะเบียนตามประเภทสินค้าที่ระบุ", "เมื่อสร้างสรรค์งานเสร็จ โดยไม่ต้องจดทะเบียน", "เมื่อได้รับการรับจดทะเบียนตามกระบวนการตรวจสอบ"],
        },
        {
          label: "เอกสารหลักที่ใช้",
          cells: ["ภาพเครื่องหมาย รายการสินค้าบริการ เอกสารผู้ขอ", "หลักฐานการสร้างสรรค์และวันที่ สัญญาโอนสิทธิหากมี", "คำขอพร้อมรายละเอียดการประดิษฐ์และข้อถือสิทธิ"],
        },
        {
          label: "จุดที่พบปัญหาบ่อย",
          cells: [
            "ยื่นไม่ครอบคลุมประเภทสินค้าที่ขายจริง หรือเหมือนเครื่องหมายเดิม",
            "จ้างผลิตงานแต่ไม่มีข้อสัญญาโอนสิทธิ ทำให้สิทธิยังอยู่กับผู้รับจ้าง",
            "เปิดเผยการประดิษฐ์ต่อสาธารณะก่อนยื่นคำขอ",
          ],
        },
      ],
      note: "ควรตรวจความเหมือนคล้ายก่อนยื่นเครื่องหมายการค้า และวางข้อสัญญาเรื่องสิทธิในงานก่อนเริ่มจ้างผลิต",
    },
    faqs: [
      {
        question: "ควรตรวจอะไรก่อนยื่นจดเครื่องหมายการค้า",
        answer:
          "ตรวจว่ามีเครื่องหมายที่เหมือนหรือคล้ายจดไว้ในประเภทสินค้าเดียวกันหรือไม่ และตรวจว่าคำที่ใช้ไม่เป็นคำสามัญหรือคำบรรยายลักษณะสินค้าจนขาดลักษณะบ่งเฉพาะ",
      },
      {
        question: "จดเครื่องหมายแล้วคุ้มครองทุกสินค้าไหม",
        answer:
          "ไม่ การคุ้มครองผูกกับรายการสินค้าและบริการที่ระบุไว้ในคำขอ หากขยายไปสินค้ากลุ่มใหม่ในภายหลัง มักต้องยื่นคำขอเพิ่มสำหรับกลุ่มนั้น",
      },
      {
        question: "ใช้ชื่อบริษัทเป็นแบรนด์อยู่แล้ว ต้องจดอีกไหม",
        answer:
          "การจดทะเบียนบริษัทกับการจดเครื่องหมายการค้าเป็นเรื่องต่างกัน การมีชื่อในทะเบียนธุรกิจไม่ได้ให้สิทธิห้ามผู้อื่นใช้เครื่องหมายที่คล้ายกันกับสินค้าเดียวกัน",
      },
      {
        question: "ลิขสิทธิ์ต้องจดทะเบียนไหม",
        answer:
          "ลิขสิทธิ์เกิดขึ้นเมื่อสร้างสรรค์งานโดยไม่ต้องจดทะเบียน แต่การแจ้งข้อมูลและการเก็บหลักฐานวันสร้างงานช่วยให้พิสูจน์ความเป็นเจ้าของได้ง่ายขึ้นเมื่อมีข้อพิพาท",
      },
      {
        question: "จ้างฟรีแลนซ์ทำโลโก้ สิทธิเป็นของใคร",
        answer:
          "ต้องดูข้อสัญญา หากไม่ได้ตกลงเรื่องการโอนสิทธิไว้ สิทธิในงานอาจยังอยู่กับผู้สร้างสรรค์ ทางที่ปลอดภัยคือระบุการโอนสิทธิและขอบเขตการใช้งานให้ชัดในสัญญาก่อนเริ่มงาน",
      },
      {
        question: "พบสินค้าลอกเลียนบนแพลตฟอร์มออนไลน์ทำอย่างไร",
        answer:
          "เก็บหลักฐานหน้าประกาศขายพร้อมวันเวลา แล้วดำเนินการแจ้งตามช่องทางของแพลตฟอร์มโดยอ้างสิทธิที่มี ควบคู่กับการมีหนังสือแจ้งเตือน และพิจารณาดำเนินคดีหากยังไม่หยุด",
      },
      {
        question: "ได้รับหนังสือกล่าวหาว่าละเมิดควรทำอย่างไร",
        answer:
          "อย่าตอบรับหรือปฏิเสธทันทีก่อนตรวจข้อเท็จจริง ควรตรวจว่าผู้กล่าวหามีสิทธิจริงและขอบเขตเพียงใด พร้อมรวบรวมหลักฐานการใช้งานของเราเอง แล้วให้ทนายความร่างหนังสือตอบ",
      },
      {
        question: "สิทธิบัตรกับอนุสิทธิบัตรเลือกอย่างไร",
        answer:
          "ขึ้นกับลักษณะและระดับการประดิษฐ์ รวมถึงระยะเวลาคุ้มครองและกระบวนการตรวจสอบที่ต่างกัน ควรให้ผู้เชี่ยวชาญประเมินจากรายละเอียดทางเทคนิคก่อนเลือกช่องทางยื่น",
      },
      {
        question: "เปิดตัวสินค้าไปแล้วยังยื่นสิทธิบัตรได้ไหม",
        answer:
          "การเปิดเผยต่อสาธารณะก่อนยื่นอาจกระทบเงื่อนไขความใหม่ จึงควรยื่นคำขอก่อนเปิดเผย หากเปิดเผยแล้วควรปรึกษาโดยเร็วเพื่อประเมินทางเลือกที่ยังเหลืออยู่",
      },
      {
        question: "สัญญาอนุญาตให้ใช้สิทธิควรมีอะไร",
        answer:
          "ควรระบุสิทธิที่อนุญาต ขอบเขตพื้นที่และระยะเวลา ความเป็นสิทธิเดียวหรือไม่ ค่าตอบแทนและการรายงาน มาตรฐานการใช้เครื่องหมาย เหตุเลิกสัญญา และผลเมื่อมีการละเมิดโดยบุคคลที่สาม",
      },
      {
        question: "เครื่องหมายการค้าต่ออายุได้ไหม",
        answer:
          "ต่ออายุได้ตามรอบที่กฎหมายกำหนด และต้องยื่นภายในกรอบเวลา การปล่อยให้สิ้นอายุทำให้เสียสิทธิและอาจมีผู้อื่นยื่นเครื่องหมายที่คล้ายกันเข้ามาแทน",
      },
      {
        question: "อยากให้ดูแลตั้งแต่ตรวจถึงจดและบังคับสิทธิได้ไหม",
        answer:
          "ได้ ทีมงานรับตรวจความเหมือนคล้าย จัดเตรียมและยื่นคำขอ ติดตามผลกับหน่วยงาน ร่างสัญญาที่เกี่ยวข้อง และดำเนินการเมื่อมีการละเมิด นำรายละเอียดแบรนด์เข้ามาปรึกษาได้ก่อน",
      },
    ],
    related: ["corporate", "pdpa", "litigation"],
    imageAlt: "ทีมกฎหมายทรัพย์สินทางปัญญาตรวจเอกสารคำขอเครื่องหมายการค้าในสำนักงาน",
  },

  "notary-international": {
    answer:
      "งานเอกสารระหว่างประเทศของสำนักงานครอบคลุมการรับรองลายมือชื่อและเอกสารโดยทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร การแปลเอกสารพร้อมรับรองคำแปล การรับรองนิติกรณ์ที่กระทรวงการต่างประเทศ และการยื่นต่อสถานทูตหรือหน่วยงานปลายทาง โดยดูลำดับขั้นให้ตรงกับที่ผู้รับเอกสารกำหนด",
    seoTitle: "โนตารีและเอกสารระหว่างประเทศ — รับรอง แปล และนิติกรณ์",
    seoDesc:
      "รับรองลายมือชื่อและเอกสารโดยทนายความ แปลพร้อมรับรองคำแปล นิติกรณ์กระทรวงการต่างประเทศ และยื่นสถานทูต พร้อมลำดับขั้นและข้อควรระวัง",
    audience: [
      "ผู้ที่ต้องส่งเอกสารไทยไปใช้กับหน่วยงานหรือมหาวิทยาลัยในต่างประเทศ",
      "ผู้ที่ได้รับเอกสารจากต่างประเทศและต้องใช้กับหน่วยงานไทย",
      "บริษัทที่ต้องรับรองหนังสือมอบอำนาจและเอกสารบริษัทเพื่อใช้ข้ามประเทศ",
      "ผู้ยื่นวีซ่าหรือขอถิ่นที่อยู่ที่ต้องใช้เอกสารรับรองครบชุด",
      "ผู้ที่ถูกปฏิเสธเอกสารและต้องตรวจว่าขั้นตอนใดขาดไป",
    ],
    compare: {
      heading: "รับรองโดยทนายความ รับรองคำแปล และนิติกรณ์ ต่างกันอย่างไร",
      intro:
        "สามขั้นนี้มักถูกเรียกรวมกันว่ารับรองเอกสาร แต่ทำหน้าที่ต่างกัน และหน่วยงานปลายทางอาจต้องการเพียงบางขั้นหรือครบทุกขั้น",
      columns: ["รับรองโดยทนายความ", "รับรองคำแปล", "นิติกรณ์กระทรวงการต่างประเทศ"],
      rows: [
        {
          label: "รับรองอะไร",
          cells: ["ลายมือชื่อ ตัวบุคคล หรือข้อเท็จจริงตามที่ขอ", "ความถูกต้องตรงกันของคำแปลกับต้นฉบับ", "ความถูกต้องของตราและลายมือชื่อของหน่วยงานผู้ออกเอกสาร"],
        },
        {
          label: "ใช้กับกรณีใด",
          cells: ["หนังสือมอบอำนาจ คำให้การ เอกสารบริษัท", "เอกสารทะเบียนราษฎรและเอกสารการศึกษาที่ต้องใช้ต่างประเทศ", "เอกสารราชการไทยที่หน่วยงานต่างประเทศขอให้ผ่านการรับรองชั้นรัฐ"],
        },
        {
          label: "ต้องมาด้วยตนเองหรือไม่",
          cells: ["โดยทั่วไปผู้ลงนามต้องแสดงตัวต่อผู้ทำคำรับรอง", "ไม่จำเป็น ใช้เอกสารต้นฉบับหรือสำเนาที่ถูกต้อง", "มอบให้ผู้แทนดำเนินการได้ตามหลักเกณฑ์"],
        },
        {
          label: "ลำดับที่มักถูกสลับ",
          cells: [
            "รับรองลายมือชื่อหลังนำไปแปลแล้ว ทำให้ต้องแปลใหม่",
            "แปลจากสำเนาที่ไม่ตรงกับต้นฉบับที่จะยื่น",
            "ยื่นนิติกรณ์ก่อนมีคำแปลที่รับรอง ทำให้ต้องกลับมาเริ่มใหม่",
          ],
        },
      ],
      note: "ควรถามหน่วยงานปลายทางก่อนว่าต้องการเอกสารรูปแบบใดและต้องผ่านขั้นใดบ้าง แล้วจึงเริ่มดำเนินการตามลำดับนั้น",
    },
    faqs: [
      {
        question: "โนตารีในไทยคือใคร",
        answer:
          "ในประเทศไทยงานลักษณะนี้ดำเนินการโดยทนายความผู้ทำคำรับรองลายมือชื่อและเอกสารที่ได้รับอนุญาตตามหลักเกณฑ์ของสภาทนายความ ซึ่งเป็นผู้ทำคำรับรองในเอกสารที่ต้องใช้กับหน่วยงานต่างประเทศ",
      },
      {
        question: "ประเทศไทยใช้ Apostille หรือไม่",
        answer:
          "แนวปฏิบัติสำหรับเอกสารไทยโดยทั่วไปใช้ช่องทางรับรองนิติกรณ์และการรับรองของสถานทูตหรือหน่วยงานปลายทาง ท่านควรตรวจกับหน่วยงานผู้รับเอกสารว่าต้องการรูปแบบใดก่อนเริ่มดำเนินการ",
      },
      {
        question: "ต้องใช้ต้นฉบับหรือสำเนาก็ได้",
        answer:
          "หลายขั้นตอนต้องใช้ต้นฉบับหรือสำเนาที่หน่วยงานผู้ออกเอกสารรับรอง โดยเฉพาะเอกสารทะเบียนราษฎรและเอกสารการศึกษา ควรเตรียมต้นฉบับไว้เสมอเพื่อไม่ให้เสียเวลาย้อนกลับ",
      },
      {
        question: "แปลเองแล้วให้รับรองได้ไหม",
        answer:
          "โดยทั่วไปหน่วยงานต้องการคำแปลที่จัดทำและรับรองโดยผู้มีคุณสมบัติ เพราะการรับรองคือการยืนยันว่าคำแปลตรงกับต้นฉบับ การแปลเองมักถูกปฏิเสธหรือถูกขอให้จัดทำใหม่",
      },
      {
        question: "ชื่อในเอกสารสะกดไม่ตรงกันจะเป็นปัญหาไหม",
        answer:
          "เป็นสาเหตุการถูกตีกลับที่พบบ่อยที่สุด ควรยึดการสะกดตามหนังสือเดินทางเป็นหลักและให้ทุกฉบับสะกดเหมือนกัน หากมีการเปลี่ยนชื่อหรือนามสกุลควรเตรียมเอกสารการเปลี่ยนไว้ด้วย",
      },
      {
        question: "เอกสารจากต่างประเทศจะใช้ในไทยต้องทำอะไร",
        answer:
          "โดยทั่วไปต้องผ่านการรับรองในประเทศต้นทางตามช่องทางที่กำหนด แล้วนำมาแปลเป็นภาษาไทยพร้อมรับรองคำแปล และผ่านขั้นตอนรับรองในไทยตามที่หน่วยงานผู้รับกำหนด",
      },
      {
        question: "หนังสือมอบอำนาจทำจากต่างประเทศใช้ได้ไหม",
        answer:
          "ใช้ได้เมื่อรับรองถูกต้องตามลำดับ และควรระบุขอบเขตอำนาจให้ตรงกับงานที่จะทำในไทย เช่น การโอนที่ดินหรือการดำเนินคดี เพราะหน่วยงานไทยจะดูว่าอำนาจครอบคลุมการกระทำนั้นหรือไม่",
      },
      {
        question: "ใช้เวลานานเท่าไร",
        answer:
          "ขึ้นกับจำนวนขั้นตอนที่หน่วยงานปลายทางกำหนด จำนวนฉบับ และคิวของหน่วยงานที่รับรอง ทีมงานจะแจ้งลำดับขั้นและสิ่งที่ต้องเตรียมให้ก่อนเริ่ม เพื่อไม่ให้ต้องย้อนกลับกลางทาง",
      },
      {
        question: "เอกสารถูกปฏิเสธเพราะอะไรบ่อยที่สุด",
        answer:
          "ที่พบบ่อยคือสะกดชื่อไม่ตรงกัน ใช้สำเนาที่ไม่ได้รับรอง ลำดับการรับรองสลับกัน คำแปลไม่ครบทุกตราและทุกข้อความในเอกสาร และเอกสารที่หน่วยงานปลายทางกำหนดอายุแต่ยื่นเกินกำหนด",
      },
      {
        question: "อยู่ต่างจังหวัดหรือต่างประเทศ ดำเนินการได้ไหม",
        answer:
          "ได้ในหลายกรณี บางขั้นตอนใช้การส่งเอกสารและหนังสือมอบอำนาจ แต่ขั้นที่ต้องรับรองลายมือชื่อผู้ลงนามต้องมีการแสดงตัวต่อผู้ทำคำรับรอง ทีมงานจะจัดลำดับให้เหมาะกับที่ท่านอยู่",
      },
      {
        question: "ต้องเตรียมกี่ชุด",
        answer:
          "ควรเตรียมเผื่อชุดสำรองอย่างน้อยหนึ่งชุด เพราะหน่วยงานปลายทางบางแห่งเก็บเอกสารต้นฉบับไว้ การทำเพิ่มภายหลังต้องเริ่มลำดับรับรองใหม่ทั้งชุด",
      },
      {
        question: "จะให้สำนักงานดูแลทั้งกระบวนการได้ไหม",
        answer:
          "ได้ ทีมงานรับตรวจเอกสารตั้งต้น จัดทำคำแปลพร้อมรับรอง ทำคำรับรองโดยทนายความ ยื่นนิติกรณ์ และประสานหน่วยงานหรือสถานทูตปลายทางในเรื่องเดียวกัน ปรึกษาก่อนได้เพื่อประเมินเป็นรายเรื่อง",
      },
    ],
    related: ["family", "corporate", "property"],
    imageAlt: "ทนายความผู้ทำคำรับรองลายมือชื่อตรวจเอกสารระหว่างประเทศพร้อมคำแปลในสำนักงาน",
  },

  pdpa: {
    answer:
      "งานคุ้มครองข้อมูลส่วนบุคคลของสำนักงานครอบคลุมการจัดทำแผนผังการไหลของข้อมูล นโยบายความเป็นส่วนตัวและคำขอความยินยอมที่ใช้ได้จริง สัญญากับผู้ประมวลผลข้อมูล กระบวนการรับคำขอใช้สิทธิของเจ้าของข้อมูล และแผนรับมือเหตุข้อมูลรั่วไหล โดยเขียนให้ตรงกับระบบงานที่องค์กรใช้อยู่",
    seoTitle: "PDPA และข้อมูลส่วนบุคคล — นโยบาย สัญญา และการใช้สิทธิ",
    seoDesc:
      "จัดทำแผนผังข้อมูล นโยบายความเป็นส่วนตัว คำขอความยินยอม สัญญาผู้ประมวลผล กระบวนการใช้สิทธิ และแผนรับมือข้อมูลรั่วไหล พร้อมขั้นตอนปฏิบัติ",
    audience: [
      "ธุรกิจที่เก็บข้อมูลลูกค้าผ่านเว็บไซต์ แอป หรือหน้าร้าน",
      "ฝ่ายบุคคลที่เก็บข้อมูลผู้สมัครงานและพนักงาน",
      "ธุรกิจที่ส่งข้อมูลให้ผู้ให้บริการภายนอก เช่น ระบบคลาวด์หรือคอลเซ็นเตอร์",
      "องค์กรที่ได้รับคำขอใช้สิทธิหรือข้อร้องเรียนจากเจ้าของข้อมูล",
      "องค์กรที่ต้องเตรียมแผนรับมือกรณีข้อมูลรั่วไหล",
    ],
    compare: {
      heading: "ฐานความยินยอม กับ ฐานทางกฎหมายอื่น",
      intro:
        "ความเข้าใจผิดที่พบบ่อยคือทุกการเก็บข้อมูลต้องขอความยินยอม ความจริงคือความยินยอมเป็นเพียงฐานหนึ่ง และการเลือกฐานผิดทำให้กระบวนการทั้งชุดต้องแก้",
      columns: ["ใช้ฐานความยินยอม", "ใช้ฐานอื่นตามที่กฎหมายกำหนด"],
      rows: [
        {
          label: "ลักษณะการใช้งาน",
          cells: ["กิจกรรมที่เจ้าของข้อมูลเลือกได้ เช่น การตลาดทางอีเมล", "กิจกรรมที่จำเป็นต่อการปฏิบัติตามสัญญาหรือหน้าที่ตามกฎหมาย"],
        },
        {
          label: "สิ่งที่ต้องเตรียม",
          cells: ["ข้อความขอความยินยอมที่แยกชัด ไม่พ่วงเงื่อนไขอื่น และระบบเก็บหลักฐาน", "เอกสารระบุวัตถุประสงค์และฐานที่ใช้ พร้อมการแจ้งเจ้าของข้อมูล"],
        },
        {
          label: "การถอนความยินยอม",
          cells: ["ต้องถอนได้ง่ายเท่ากับที่ให้ และต้องหยุดใช้ข้อมูลนั้น", "ไม่ใช้กลไกถอน แต่ยังต้องรองรับสิทธิอื่นของเจ้าของข้อมูล"],
        },
        {
          label: "ข้อผิดพลาดที่พบบ่อย",
          cells: [
            "ติ๊กยินยอมล่วงหน้า หรือพ่วงยินยอมกับการยอมรับเงื่อนไขบริการ",
            "อ้างฐานอื่นแต่เขียนวัตถุประสงค์กว้างจนไม่สอดคล้องกับการใช้จริง",
          ],
        },
      ],
      note: "ควรเริ่มจากแผนผังการไหลของข้อมูลจริงก่อน แล้วจึงเลือกฐานและเขียนเอกสารให้ตรงกับระบบที่ใช้",
    },
    faqs: [
      {
        question: "ธุรกิจขนาดเล็กต้องทำตาม PDPA ไหม",
        answer:
          "หน้าที่ตามกฎหมายไม่ได้ยกเว้นตามขนาดธุรกิจ แต่ปริมาณเอกสารและมาตรการควรได้สัดส่วนกับข้อมูลที่เก็บและความเสี่ยง ธุรกิจเล็กสามารถเริ่มจากชุดเอกสารพื้นฐานที่ใช้ได้จริง",
      },
      {
        question: "เริ่มต้นควรทำอะไรก่อน",
        answer:
          "เริ่มจากทำแผนผังว่าองค์กรเก็บข้อมูลอะไร จากใคร เก็บที่ไหน ใครเข้าถึงได้ ส่งต่อให้ใคร และเก็บนานเท่าไร เพราะเอกสารทุกฉบับต่อจากนี้ต้องอ้างข้อเท็จจริงชุดนี้",
      },
      {
        question: "นโยบายความเป็นส่วนตัวลอกจากเว็บอื่นได้ไหม",
        answer:
          "ไม่ควร เพราะนโยบายต้องตรงกับสิ่งที่องค์กรทำจริง การใช้ข้อความที่ไม่ตรงกับระบบงานสร้างความเสี่ยงมากกว่าไม่มี เมื่อมีข้อร้องเรียนจะถูกเทียบกับการปฏิบัติจริง",
      },
      {
        question: "ต้องมีเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลหรือไม่",
        answer:
          "ขึ้นกับลักษณะและปริมาณข้อมูลที่ประมวลผลตามหลักเกณฑ์ที่กำหนด องค์กรที่ไม่เข้าเงื่อนไขก็ยังควรกำหนดผู้รับผิดชอบภายในให้ชัด เพื่อให้มีผู้ตอบคำขอใช้สิทธิได้ทันกำหนด",
      },
      {
        question: "เก็บข้อมูลผู้สมัครงานได้นานแค่ไหน",
        answer:
          "ควรกำหนดระยะเวลาเก็บให้สอดคล้องกับวัตถุประสงค์ที่แจ้งไว้ และลบหรือทำลายเมื่อครบกำหนด การเก็บใบสมัครไว้ไม่มีกำหนดโดยไม่ได้แจ้งวัตถุประสงค์เป็นประเด็นที่พบบ่อย",
      },
      {
        question: "ใช้กล้องวงจรปิดต้องทำอะไร",
        answer:
          "ควรมีป้ายแจ้งการบันทึกภาพในจุดที่มองเห็นได้ กำหนดวัตถุประสงค์และระยะเวลาเก็บภาพ จำกัดผู้เข้าถึง และมีขั้นตอนกรณีมีผู้ขอดูภาพ",
      },
      {
        question: "ส่งข้อมูลให้ผู้ให้บริการภายนอกต้องทำสัญญาไหม",
        answer:
          "ควรมีข้อสัญญาที่กำหนดขอบเขตการใช้ข้อมูล มาตรการความปลอดภัย การใช้ผู้รับจ้างช่วง การแจ้งเหตุละเมิด และการคืนหรือลบข้อมูลเมื่อสิ้นสุดสัญญา",
      },
      {
        question: "ส่งข้อมูลไปเก็บบนคลาวด์ต่างประเทศได้ไหม",
        answer:
          "ทำได้โดยต้องพิจารณาหลักเกณฑ์เรื่องการส่งข้อมูลออกนอกประเทศและมาตรการคุ้มครองที่เหมาะสม รวมถึงระบุเรื่องนี้ในนโยบายและสัญญากับผู้ให้บริการ",
      },
      {
        question: "เจ้าของข้อมูลขอให้ลบข้อมูล ต้องลบทุกกรณีไหม",
        answer:
          "ไม่ทุกกรณี เพราะบางข้อมูลต้องเก็บตามหน้าที่ตามกฎหมายหรือเพื่อใช้สิทธิเรียกร้อง ควรมีขั้นตอนตรวจคำขอ บันทึกเหตุผลการตอบ และแจ้งผลให้ผู้ขอทราบภายในกรอบเวลา",
      },
      {
        question: "ข้อมูลรั่วไหลต้องทำอะไรบ้าง",
        answer:
          "ต้องประเมินเหตุและความเสี่ยงโดยเร็ว จำกัดความเสียหาย บันทึกเหตุการณ์ และแจ้งตามหน้าที่ที่กฎหมายกำหนดภายในกรอบเวลา จึงควรมีแผนรับมือเตรียมไว้ก่อนเกิดเหตุ",
      },
      {
        question: "ต้องอบรมพนักงานหรือไม่",
        answer:
          "ควรทำ เพราะเหตุละเมิดส่วนใหญ่เกิดจากการปฏิบัติงานประจำวัน เช่น ส่งอีเมลผิดคน หรือแชร์ไฟล์เกินความจำเป็น การอบรมพร้อมเก็บหลักฐานยังช่วยแสดงความรับผิดชอบขององค์กร",
      },
      {
        question: "ให้สำนักงานจัดทำชุดเอกสารทั้งชุดได้ไหม",
        answer:
          "ได้ ทีมงานรับจัดทำแผนผังข้อมูล นโยบายภายในและภายนอก ข้อความขอความยินยอม สัญญากับผู้ประมวลผล แบบฟอร์มคำขอใช้สิทธิ และแผนรับมือเหตุละเมิด โดยเขียนให้ตรงกับระบบงานจริงขององค์กร",
      },
    ],
    related: ["corporate", "ip", "labour"],
    imageAlt: "ที่ปรึกษากฎหมายทบทวนนโยบายคุ้มครองข้อมูลส่วนบุคคลกับทีมงานในสำนักงาน",
  },
};
